__webpack_require__.p = "https://cdn.workspaces-web.com/";